'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _roleCategories = require('../actions/roleCategories');

var defaultState = {
    roleCategories: [],
    requestingRoleCategories: false
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {
        case _roleCategories.actionTypes.FETCH_ROLE_CATEGORIES_REQUEST:
            return _extends({}, state, {
                requestingRoleCategories: true
            });
        case _roleCategories.actionTypes.FETCH_ROLE_CATEGORIES_FAILED:
            return _extends({}, state, {
                requestingRoleCategories: false
            });
        case _roleCategories.actionTypes.FETCH_ROLE_CATEGORIES_SUCCEEDED:
            return _extends({}, state, {
                roleCategories: action.roleCategories,
                requestingRoleCategories: false
            });
        default:
            return state;
    }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/roleCategories.js
// module id = 2259
// module chunks = 0